import * as actions from "./actionsTypes";

const initialData = {
  loaderDiciplinaryCase: false,
  loaderDiciplinaryCases: false,
  saveLoaderDiciplinaryCase: false,
  disciplinaryCases: null,
  disciplinaryCase: null,
  disciplinaryCaseFaild: null,
  disciplinaryCasesFaild: null,
  formDisciplinaryCaseFaild: null,
  loaderDiciplinaryCasesAll: false,
  disciplinaryCasesAll: null,
  disciplinaryCasesFaildAll: null,
  loaderComments: false,
  comments: null,
  commentsFaild: null,
  createCommentLoader: false,
  createCommentFaild: null,
};

export default function DisciplinaryCaseReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_DISCIPLINARY_CASE:
      return { ...state, loaderDiciplinaryCase: action.payload };
    case actions.LOADER_DISCIPLINARY_CASES:
      return { ...state, loaderDiciplinaryCases: action.payload };
    case actions.SAVE_LOADER_DISCIPLINARY_CASE:
      return { ...state, saveLoaderDiciplinaryCase: action.payload };
    case actions.GET_DISCIPLINARY_CASES:
      return { ...state, disciplinaryCases: action.payload };
    case actions.GET_DISCIPLINARY_CASE:
      return { ...state, disciplinaryCase: action.payload };
    case actions.FAILD_DISCIPLINARY_CASES:
      return { ...state, disciplinaryCasesFaild: action.payload };
    case actions.FAILD_DISCIPLINARY_CASE:
      return { ...state, disciplinaryCaseFaild: action.payload };
    case actions.FORM_DISCIPLINARY_CASE_FAILD:
      return { ...state, formDisciplinaryCaseFaild: action.payload };
    case actions.LOADER_DISCIPLINARY_CASES_ALL:
      return { ...state, loaderDiciplinaryCasesAll: action.payload };
    case actions.GET_DISCIPLINARY_CASES_ALL:
      return { ...state, disciplinaryCasesAll: action.payload };
    case actions.FAILD_DISCIPLINARY_CASES_ALL:
      return { ...state, disciplinaryCasesFaildAll: action.payload };
    case actions.LOADER_COMMENTS:
      return { ...state, loaderComments: action.payload };
    case actions.GET_COMMENTS:
      return { ...state, comments: action.payload, commentsFaild: null };
    case actions.FAILD_COMMENTS:
      return { ...state, commentsFaild: action.payload, comments: null };
    case actions.CREATE_COMMENT:
      return { ...state, createCommentLoader: false, createCommentFaild: null };
    case actions.CREATE_COMMENT_FAILD:
      return {
        ...state,
        createCommentFaild: action.payload,
        createCommentLoader: false,
      };
    case actions.RESET_COMMENTS:
      return {
        ...state,
        comments: null,
        commentsFaild: null,
        createCommentLoader: false,
        createCommentFaild: null,
      };
    default:
      return state;
  }
}
